import { ReleaseNoteSectionViewOf } from 'bff';
import { cn } from 'ui';
import { InlineText } from '../RichText';

// Two or more points read better side by side.
const TWO_COLUMNS_FROM = 2;

// Short notes under a hairline each, as a graphic's annotations.
export const BulletsSection = ({
  section: { content },
}: {
  section: ReleaseNoteSectionViewOf<'bullets'>;
}) => (
  <ul
    className={cn(
      'grid gap-x-6 gap-y-5',
      content.items.length >= TWO_COLUMNS_FROM && 'sm:grid-cols-2',
    )}
  >
    {content.items.map((item, index) => (
      <li
        key={index}
        className='border-t border-stone-200 pt-3 text-sm leading-relaxed text-stone-600'
      >
        {item.title && (
          <span className='font-semibold text-foreground'>{item.title} </span>
        )}
        <InlineText text={item.body} />
      </li>
    ))}
  </ul>
);
